import { useNavigate } from 'react-router-dom';
import SyllabusDownloadButton from '../SyllabusDownloadButton/SyllabusDownloadButton';
import styles from './BachilleratoView.module.css';


function BachilleratoView({ bachillerato }) {
  const navigate = useNavigate();

  return (
    <>
      {/* ── Banner con overlay ── */}
      <div className={styles.banner}>
        {bachillerato.bannerImageS3 ? (
          <img src={bachillerato.bannerImageS3} alt={bachillerato.name} className={styles.bannerImg} />
        ) : (
          <div className={styles.bannerPlaceholder} />
        )}
        <div className={styles.bannerOverlay}>
          <div className={styles.bannerLeft}>
            <h1 className={styles.bannerTitle}>{bachillerato.name}</h1>
            {bachillerato.heroHighlights?.length > 0 && (
              <div className={styles.heroGrid}>
                {bachillerato.heroHighlights.map((h, i) => (
                  <div key={i} className={styles.heroItem}>
                    <span className={styles.heroLabel}>{h.label}</span>
                    <span className={styles.heroValue}>{h.value}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
          <div className={styles.bannerRight}>
            <button
              type="button"
              className={styles.bannerCta}
              onClick={() => navigate(`/inscripcion?careerId=${bachillerato._id}`)}
            >
              Inscríbete ahora
            </button>
          </div>
        </div>
      </div>

      {/* ── Two-column content ── */}
      <div className={styles.content}>

        {/* ── Left column ── */}
        <div className={styles.leftCol}>

          {/* Plataforma + objetos de aprendizaje */}
          {bachillerato.platformDescription && (
            <section className={styles.section}>
              <p className={styles.platformDesc}>{bachillerato.platformDescription}</p>
              {bachillerato.learningObjects?.length > 0 && (
                <ul className={styles.learningGrid}>
                  {bachillerato.learningObjects.map((obj, i) => (
                    <li key={i} className={styles.learningItem}>{obj}</li>
                  ))}
                </ul>
              )}
            </section>
          )}

          {/* Audiencia objetivo */}
          {bachillerato.targetAudience && (
            <section className={styles.section}>
              {bachillerato.targetAudience.description && (
                <p className={styles.targetDesc}>{bachillerato.targetAudience.description}</p>
              )}
              {bachillerato.targetAudience.idealFor?.length > 0 && (
                <>
                  <p className={styles.idealForTitle}>Es ideal para quienes buscan:</p>
                  <ul className={styles.bulletList}>
                    {bachillerato.targetAudience.idealFor.map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                </>
              )}
            </section>
          )}

          {/* LMS / Plataforma */}
          {bachillerato.lms && (
            <section className={styles.lmsSection}>
              <img src="/prepaschology.png" alt="Plataforma LMS" className={styles.lmsImg} />
              <div className={styles.lmsContent}>
                <p className={styles.lmsEyebrow}>Plataforma (LMS)</p>
                <h2 className={styles.lmsName}>{bachillerato.lms.name}</h2>
                {bachillerato.lms.description && (
                  <p className={styles.lmsDesc}>{bachillerato.lms.description}</p>
                )}
                {bachillerato.lms.features?.length > 0 && (
                  <ul className={styles.bulletList}>
                    {bachillerato.lms.features.map((f, i) => (
                      <li key={i}>{f}</li>
                    ))}
                  </ul>
                )}
              </div>
            </section>
          )}

        </div>

        {/* ── Right column ── */}
        <div className={styles.rightCol}>

          {/* Info card */}
          {bachillerato.generalInfo && (
            <div className={styles.infoCard}>
              <div className={styles.infoRow}>
                <span className={styles.infoIcon}>📅</span>
                <div>
                  <p className={styles.infoLabel}>Duración</p>
                  <p className={styles.infoValue}>{bachillerato.generalInfo.duration}</p>
                </div>
              </div>
              <div className={styles.infoRow}>
                <span className={styles.infoIcon}>🕐</span>
                <div>
                  <p className={styles.infoLabel}>Horarios</p>
                  <p className={styles.infoValue}>{bachillerato.generalInfo.schedule}</p>
                </div>
              </div>
              <div className={styles.infoRow}>
                <span className={styles.infoIcon}>📚</span>
                <div>
                  <p className={styles.infoLabel}>Materias</p>
                  <p className={styles.infoValue}>{bachillerato.generalInfo.subjects}</p>
                </div>
              </div>
              {bachillerato.generalInfo.graduation && (
                <div className={styles.infoRow}>
                  <span className={styles.infoIcon}>🎓</span>
                  <div>
                    <p className={styles.infoLabel}>Titulación</p>
                    <p className={styles.infoValue}>{bachillerato.generalInfo.graduation}</p>
                  </div>
                </div>
              )}
              <button
                type="button"
                className={styles.ctaBtn}
                onClick={() => navigate(`/inscripcion?careerId=${bachillerato._id}`)}
              >
                Comenzar tu inscripción ahora
              </button>
            </div>
          )}

          <SyllabusDownloadButton url={bachillerato.syllabusUrl} fullWidth />

          {/* Admisiones y Becas + imagen */}
          <div className={styles.promoCard}>
            <div className={styles.promoTextSection}>
              <p className={styles.promoTitle}>
                Obtén una beca descuento de hasta el <strong>65%</strong>
              </p>
              <button
                type="button"
                className={styles.promoBtn}
                onClick={() => navigate('/becas')}
              >
                Calcula tu beca aquí
              </button>
            </div>
            <div className={styles.promoImageSection}>
              <p className={styles.clasesTitle}>¡Aprender es tan fácil como ver tu serie favorita!</p>
              <p className={styles.clasesText}>Tu educación, cuando quieras y donde quieras.</p>
              <img src="/pictures/pictures_33.png" alt="" className={styles.promoImg} aria-hidden="true" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default BachilleratoView;
